import style from "css/hotdesking.module.css";
import React, { useCallback, useEffect, useState } from "react";
import { Button } from "antd-mobile";
import {
  CalendarOutlined,
  EnvironmentOutlined,
  SearchOutlined,
  StarOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import SearchOptions from "./SearchOptions";
import SearchFavorite from "./SearchFavorite";
import SearchUser from "./SearchUser";
import SearchTeam from "./SearchTeam";
import axios from "axios";
import HotdeskingConfig from "../Config";
import { useTranslation } from "react-i18next";

function SearchContent({
  view,
  date,
  setDate,
  time,
  setTime,
  location,
  setLocation,
  departmentId,
  isFind,
  setIsFind,
  onShowBook,
  serverDate,
  workTime,
  setDefaultLocation,
}) {
  return (
    <>
      {view === "today" ? (
        <Today
          date={date}
          setDate={setDate}
          time={time}
          setTime={setTime}
          location={location}
          setLocation={setLocation}
          departmentId={departmentId}
          isFind={isFind}
          setIsFind={setIsFind}
          serverDate={serverDate}
          workTime={workTime}
          setDefaultLocation={setDefaultLocation}
        />
      ) : (
        <Employee onShowBook={onShowBook} />
      )}
    </>
  );
}

function Today({
  date,
  setDate,
  time,
  setTime,
  location,
  setLocation,
  departmentId,
  isFind,
  setIsFind,
  serverDate,
  workTime,
  setDefaultLocation,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const onOpen = () => {
    setIsOpen(true);
  };
  const onClose = () => {
    setIsOpen(false);
  };
  return (
    <section className={`${style.search_content} ${style.today}`}>
      <SearchOptions
        isOpen={isOpen}
        onClose={onClose}
        setLocation={setLocation}
        departmentId={departmentId}
        date={date}
        time={time}
        setDate={setDate}
        setTime={setTime}
        isFind={isFind}
        setIsFind={setIsFind}
        serverDate={serverDate}
        workTime={workTime}
        setDefaultLocation={setDefaultLocation}
      />
      <Button className={style.search_indicator} onClick={onOpen}>
        <section className={style.indicator_container}>
          {location !== null ? (
            <>
              <div className={style.indicator_item}>
                <EnvironmentOutlined className={style.indicator_} />
                <p>{location.title}</p>
              </div>
              <span className={style.indicator_divider} />
              <div className={style.indicator_item}>
                <CalendarOutlined className={style.indicator_} />
                <p>{date},</p>
                <p>
                  {dayjs(new Date(date + " " + time.start)).format("HH:mm")}
                </p>
                <p>-</p>
                <p>{dayjs(new Date(date + " " + time.end)).format("HH:mm")}</p>
              </div>
            </>
          ) : (
            <div className={style.indicator_item}></div>
          )}
        </section>
      </Button>
    </section>
  );
}
function Employee({ onShowBook }) {
  const { t } = useTranslation();
  const tabList = [
    {
      key: "favorite",
      label: t("HOTDESKING.MENU.TEAM.BUTTON.FAVORITE"),
      icon: <StarOutlined className={style.item_icon} />,
    },
    {
      key: "basic",
      label: t("HOTDESKING.MENU.TEAM.BUTTON.SEARCH"),
      icon: <SearchOutlined className={style.item_icon} />,
    },
    {
      key: "department",
      label: t("HOTDESKING.MENU.TEAM.BUTTON.MY_TEAM"),
      icon: <TeamOutlined className={style.item_icon} />,
    },
  ];
  const [isSearch, setIsSearch] = useState(true);
  const [isOpenFavorite, setIsOpenFavorite] = useState(false);
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const [isOpenTeam, setIsOpenTeam] = useState(false);
  const [tab, setTab] = useState("favorite");
  const [memberList, setMemberList] = useState([]);
  const [text, setText] = useState("");

  const onSearch = useCallback(() => {
    const config = {
      params: {
        search_type: tab,
      },
    };
    axios.get(`${HotdeskingConfig.baseURI}/member`, config).then((res) => {
      setMemberList(res.data);
    });
  }, [tab]);

  useEffect(() => {
    if (isSearch && (isOpenFavorite || isOpenSearch || isOpenTeam)) {
      if (tab !== "basic") {
        onSearch();
      }
      setIsSearch(false);
    }
  }, [isOpenFavorite, isOpenSearch, isOpenTeam, isSearch, onSearch, tab]);

  const onSearchText = () => {
    if (text === "") {
      return;
    }
    const config = {
      params: {
        search_type: tab,
        search_text: text,
      },
    };
    axios.get(`${HotdeskingConfig.baseURI}/member`, config).then((res) => {
      if (res.data.length > 0) {
        setMemberList(res.data);
      } else {
        setMemberList([]);
      }
    });
  };

  //즐겨찾기 생성
  const onAddFavorite = (id) => {
    const data = {
      member_id: id,
    };
    axios.post(`${HotdeskingConfig.baseURI}/member/favorite`, data).then(() => {
      if (tab === "basic") {
        onSearchText();
      } else {
        onSearch();
      }
    });
  };
  //즐겨찾기 삭제
  const onCancelFavorite = (id) => {
    const config = {
      params: {
        member_id: id,
      },
    };
    axios
      .delete(`${HotdeskingConfig.baseURI}/member/favorite`, config)
      .then(() => {
        if (tab === "basic") {
          onSearchText();
        } else {
          onSearch();
        }
      });
  };

  const openPopup = (key) => {
    switch (key) {
      case "favorite":
        setIsOpenFavorite(true);
        break;
      case "basic":
        setIsOpenSearch(true);
        break;
      case "department":
        setIsOpenTeam(true);
        break;
      default:
        return;
    }
    setMemberList([]);
    setText("");
    setTab(key);
    setIsSearch(true);
  };
  return (
    <>
      <SearchFavorite
        isOpen={isOpenFavorite}
        onClose={() => setIsOpenFavorite(false)}
        list={memberList}
        onShowBook={onShowBook}
        onCancelFavorite={onCancelFavorite}
      />
      <SearchUser
        isOpen={isOpenSearch}
        onClose={() => setIsOpenSearch(false)}
        list={memberList}
        onShowBook={onShowBook}
        onAddFavorite={onAddFavorite}
        onCancelFavorite={onCancelFavorite}
        onSearch={onSearchText}
        text={text}
        setText={setText}
      />
      <SearchTeam
        isOpen={isOpenTeam}
        onClose={() => setIsOpenTeam(false)}
        list={memberList}
        onShowBook={onShowBook}
        onAddFavorite={onAddFavorite}
        onCancelFavorite={onCancelFavorite}
      />
      <section className={`${style.search_content} ${style.employee}`}>
        {tabList.map((item) => (
          <Button
            key={item.key}
            className={style.content_item}
            onClick={() => openPopup(item.key)}
          >
            {item.icon}
            <p>{item.label}</p>
          </Button>
        ))}
      </section>
    </>
  );
}

export default SearchContent;
